import {
    BasicResponsiveImage,
    BoundedContent,
    Column,
    GridContainer,
    H2,
    Row,
    tokens,
} from '@vp/swan';
import styled from 'styled-components';

export interface HowItWorksProps {
    title: string;
    description: string;
    image: {
        url: string;
        alt: string;
    };
    verticallyCenterContent?: boolean;
}

const Description = styled.div`
    p {
        margin-bottom: ${tokens.SwanSemSpace7};
    }
`;

export function HowItWorks({
    title,
    description,
    image,
    verticallyCenterContent = false,
}: HowItWorksProps) {
    return (
        <BoundedContent>
            <GridContainer>
                <Row>
                    <Column span={6} verticallyCenterContent={verticallyCenterContent}>
                        <H2 fontSkin="title-section">{title}</H2>
                        <Description dangerouslySetInnerHTML={{ __html: description }} />
                    </Column>
                    <Column
                        span={6}
                        spanLg={5}
                        offsetLg={1}
                        spanXl={5}
                        offsetXl={1}
                        verticallyCenterContent={verticallyCenterContent}
                    >
                        <BasicResponsiveImage aspectRatio={1} src={image.url} alt={image.alt} />
                    </Column>
                </Row>
            </GridContainer>
        </BoundedContent>
    );
}
